
import StrategyDetails from "@/components/follow-strategy/StrategyDetails";

interface FreeStrategyDetailsProps {
  strategy: {
    name: string;
    performance: string;
    riskLevel: string;
    minInvestment: string;
    since: string;
    exchange: string;
    followers?: number;
    aum?: number | null;
    winRate?: number | null;
    maxDrawdown?: number | null;
    tradesWon?: number | null;
    tradesLost?: number | null;
    description?: string;
  };
}

const FreeStrategyDetails = ({ strategy }: FreeStrategyDetailsProps) => {
  return <StrategyDetails strategy={strategy} />;
};

export default FreeStrategyDetails;
